import styled from 'styled-components';

import { theme } from 'assets/styles/theme';
import sendLocationIcon from 'assets/svg/send-location.svg';
import { Caption } from 'components/typography/Texts';

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${theme.color.lighterGray};
  border-radius: 5px;
  width: 100%;
  height: 45px;
  margin: 10px 0;
  padding: 0 12px;
`;

const Input = styled.input`
  border: none;
  outline: none;
  background: none;
  font-size: 14px;
  width: 50%;

  &::placeholder {
    color: ${theme.color.placeholderGrey};
  }
`;

const SendLocationIcon = styled.img`
  width: 25px;
  height: 25px;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

const CityName = styled(Caption)`
  cursor: default;
  color: ${theme.color.placeholderGrey};
`;

type ZipInputFieldProps = {
  zipCode: string;
  onZipChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
  cityName?: string;
};

export const ZipInputField = ({ zipCode, onZipChange, placeholder, cityName }: ZipInputFieldProps) => (
  <InputWrapper data-testid='location-input-wrapper'>
    <Input
      data-testid='location-input'
      maxLength={5}
      type='text'
      placeholder={placeholder}
      value={zipCode}
      onChange={onZipChange}
    />
    <Container>
      {cityName && <CityName data-testid='location-city-name'>{cityName}</CityName>}
      <SendLocationIcon src={sendLocationIcon} />
    </Container>
  </InputWrapper>
);
